import { combineReducers } from '@reduxjs/toolkit'
import { accessSlice, articleSlice, fileSlice, projectSlice } from 'Pages/knowledge'

export const knowledgeReducers = combineReducers({
	[accessSlice.name]: accessSlice.reducer,
	[projectSlice.name]: projectSlice.reducer,
	[articleSlice.name]: articleSlice.reducer,
	[fileSlice.name]: fileSlice.reducer,
})
